import EnhancedSeo from './enhancedSeo';
import Product from './product';
import device from './services/device';
import { wishlistModal } from './components/wishlist';

class detail {
  constructor() {
    // eslint-disable-next-line no-unused-vars
    let dev = device; // non rimuovere, serve a non far auto-rimuovere l'import

    Product.colorValue();
    Product.colorAttribute();
    Product.selectAttribute();
    Product.selectMiniSetAttribute();
    Product.availability();
    Product.addToCart();
    Product.addToCartMiniSet();
    Product.gridImagesCarousel();
    Product.addToCartMobileSEO();

    this.defaultColor();
    this.updateAttribute();
    this.updateMiniSetAttribute();
    this.updateAddToCart();
    this.updateAddToCartMiniSet();
    this.updateProductLabels();
    // this.updateNotifyMe();
    this.sizeChart();
    this.visibilitySizeGuideModalElements();
    this.controlsZoom();
    this.zoom();
    this.panningZoom();
    // this.gridImagesCarousel();
    this.toggleShare();
    this.productSetImage();
    this.sizeGuide();
    this.notifyMe();
    this.setItemClick();
    EnhancedSeo.sizeGuideClick(['.size', '.product-detail', 'pid']);
    EnhancedSeo.breadcrumbsClick(['.header-product-breadcrumb a', 'data-category-id']);
    // EnhancedSeo.productSeoValorize();
    Product.colorAttributeNoClick($('.product-wrapper .swatch-color.selected')[0], true);
    wishlistModal();
  }

  updateProductLabels() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      var $nameGroup = $('.product-name-group');
      var $labels = $('.product-tag-labels');
      var label = response.data.product.label;

      if ($labels.length === 0 && label) {
        $nameGroup.prepend('<ul class="product-tag-labels"><li><span class="product-tag-label">' + label + '</span></li></ul>');
      } else if ($labels.length > 0 && label) {
        $labels.find('span').text(label);
        $labels.removeClass('hide');
      } else if (!label && $labels.length > 0) {
        $labels.addClass('hide');
      }
    });
  }

  defaultColor() {
    $(document).ready(function () {
      if ($('.product-wrapper .swatch-color.selectable').length !== 0) {
        if (!$('.product-wrapper .swatch-color.selected').length) {
          // $('.product-wrapper .swatch-color.selectable')[0].click();
          if (!$('.product-detail').hasClass('default-click-color')) {
            $('.product-detail').addClass('default-click-color');
            Product.colorAttributeNoClick($('.product-wrapper .swatch-color.selectable')[0]);
          }

          // set title with selected color familyColorSearch
          var newTitleColor = $($('.product-wrapper .swatch-color.selectable')[0]).data('familyColorSearch');
          var oldTitleColor = $('div[data-attr="color"]').data('masterColor');
          try {
            document.title = document.title.replace(oldTitleColor, newTitleColor);
            var description = $('meta[name="description"]').attr('content');
            var ogDescription = $('meta[property="og:description"]').attr('content');
            $('meta[name="description"]').attr('content', description.replace(oldTitleColor, newTitleColor));
            $('meta[property="og:description"]').attr('content', ogDescription.replace(oldTitleColor, newTitleColor));
          } catch (error) {
            console.error(error);
          }
        }
      }
    });
  }

  updateAttribute() {
    $('body').on('product:afterAttributeSelect', function (e, response) {
      if ($('.product-detail > .bundle-items').length) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else if ($('.product-set-detail').length) {
        response.container.data('pid', response.data.product.id);
        response.container.find('.product-id').text(response.data.product.id);
      } else {
        $('.product-detail:not(".bundle-item")').attr('data-pid', response.data.product.id);
      }
    });
  }

  updateMiniSetAttribute() {
    $('body').on('product:afterMiniAttributeSelect', function (e, response) {
      response.container.find('.set-item').attr('data-pid', response.data.product.id);
    });
  }

  updateAddToCart() {
    $('body').on('product:updateAddToCart', function (e, response) {
      // Aggiorna solo i contenitori presenti nel blocco in analisi
      if ($('.product-detail .prices-add-to-cart-actions', response.$productContainer).length) {
        $('.product-detail .prices-add-to-cart-actions', response.$productContainer).html(response.product.availability.html);
      }
      if ($('#size-modal .prices-add-to-cart-actions', response.$productContainer).length) {
        $('#size-modal .prices-add-to-cart-actions', response.$productContainer).html(response.product.availability.html);
      }
      if (response.product.oosProduct) {
        $('button.add-to-cart', response.$productContainer).addClass('hidden');
        $('.availability-msg.oos', response.$productContainer).removeClass('hidden');
      } else {
        $('button.add-to-cart', response.$productContainer).removeClass('hidden');
        $('.availability-msg.oos', response.$productContainer).addClass('hidden');
      }
      $('button.add-to-cart', response.$productContainer).attr('disabled', (!response.product.readyToOrder || !response.product.available)).attr('data-pid', response.product.id);

      var enable = $('.product-availability').toArray().every(function (item) { return $(item).data('available') && $(item).data('ready-to-order'); });
      $('button.add-to-cart-global').attr('disabled', !enable);
    });
  }

  updateAddToCartMiniSet() {
    $('body').on('product:updateAddToCartMiniSet', function (e, response) {
      $('button.add-to-cart-set', response.$productContainer).attr('disabled', (!response.product.readyToOrder || !response.product.available)).attr('data-pid', response.product.id).removeClass('disabled');
    });
  }

  updateAvailability() {
    $('body').on('product:updateAvailability', function (e, response) {
      $('div.availability', response.$productContainer).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available);

      $('.availability-msg', response.$productContainer).empty().html(response.message);

      if ($('.global-availability').length) {
        var allAvailable = $('.product-availability').toArray().every(function (item) {
          return $(item).data('available');
        });

        var allReady = $('.product-availability').toArray().every(function (item) {
          return $(item).data('ready-to-order');
        });

        $('.global-availability').data('ready-to-order', allReady).data('available', allAvailable);

        $('.global-availability .availability-msg').empty().html(allReady ? response.message : response.resources.info_selectforstock);
      }
    });
  }

  updateNotifyMe() {
    const pid = $('.product-detail').attr('data-pid');

    $('body').on('product:statusUpdate', function (e, response) {
      const sizeElem = $('.size-unavailable, [data-notify-me]');
      let notifyMe = false;
      let option = [];

      for (let item in response.variationAttributes) {
        if (response.variationAttributes[item].id === 'size') {
          let arr = response.variationAttributes[item].values;
          for (let i = 0; i < arr.length; i++) {
            Object.keys(arr[i]).forEach(function (key) {
              if (key === 'selectable') {
                let values = arr[i][key];
                if (!values) {
                  option[i] = $('<option class="value-options" value="' + arr[i].id + '">' + arr[i].displayValue + '</option>');
                  notifyMe = true;
                }
              }
            });
          }
        }
      }

      let refreshSelectNotify = function ($elem, $form) {
        $elem.find('option:not([value=""])').remove();
        $elem.append(option).customSelect({
          transition: 300
        });
        $form.parsley().reset();
      };

      if (notifyMe) {
        refreshSelectNotify($('#list-size'), $('#notify-modal-' + pid + ' .notify-form'));
        sizeElem.addClass('show').removeClass('hide');
      } else {
        sizeElem.addClass('hide').removeClass('show');
      }
    });
  }

  sizeChart() {
    var $sizeChart = $('.size-chart-collapsible');

    $('.size-chart a').on('click', function (e) {
      e.preventDefault();

      var url = $(this).attr('href');

      if ($sizeChart.is(':empty')) {
        $.ajax({
          url: url,
          type: 'get',
          dataType: 'json',
          success: function (data) {
            $sizeChart.append(data.content);
          }
        });
      }

      $sizeChart.toggleClass('active');
    }.bind(this));

    $('body').on('click', function (e) {
      if ($('.size-chart').has(e.target).length <= 0) {
        $sizeChart.removeClass('active');
      }
    });
  }

  controlsZoom() {
    const modal = $(document).find('.product-zoom-modal');

    $(document).on('click', '.side-grid-images img', function (e) {
      const self = $(e.currentTarget);
      const index = self.attr('data-index');

      if (self.hasClass('loading')) {
        return;
      }

      $('#zoom-trigger').trigger('click');
      $('.product-zoom-modal').find('.zoom-thumbnail-render[data-index="' + index + '"]').trigger('click');
      $('.product-zoom-modal').find('.current').html(index);
    });

    modal.on('click', '.control', function (e) {
      e.preventDefault();
      const self = $(e.currentTarget);
      const current = self.closest(modal).find('.current');
      const length = parseInt(self.closest(modal).find('.length').text());

      if (self.hasClass('next')) {
        let next = parseInt(current.text()) + 1;
        let control = self.closest(modal).find('.zoom-thumbnail-render[data-index="' + next.toString() + '"]');

        if (next > length) {
          next = '1';
          current.text(next);
          control = self.closest(modal).find('.zoom-thumbnail-render[data-index="' + next.toString() + '"]');
          control.trigger('click');
        } else {
          current.text(next.toString());
          control.trigger('click');
        }
      } else if (self.hasClass('prev')) {
        let prev = parseInt(current.text()) - 1;
        let control = self.closest(modal).find('.zoom-thumbnail-render[data-index="' + prev.toString() + '"]');

        if (prev < 1) {
          prev = length.toString();
          current.text(prev);
          control = self.closest(modal).find('.zoom-thumbnail-render[data-index="' + prev.toString() + '"]');
          control.trigger('click');
        } else {
          current.text(prev.toString());
          control.trigger('click');
        }
      }
    });

    modal.on('click', '.close-modal', function () {
      const current = parseInt(modal.find('.current').text());
      const carousel = $('.grid-render');

      if (carousel.hasClass('owl-carousel')) {
        carousel.trigger('to.owl.carousel', [current - 1, 10, true]);
      }
    });
  }

  panningZoom() {
    $(document).on('mousemove', '#zoom-render', function (e) {
      const self = $(e.currentTarget);
      const width = self.innerWidth();
      let height = self.innerHeight();

      let x = (e.pageX - self.offset().left) / width * 100;
      let y = (e.pageY - self.offset().top) / height * 100;

      if (window.device && (window.device.type === 'mobile' || window.device.type === 'tablet')) {
        return;
      }

      if (self.hasClass('loading')) {
        return;
      }

      self.css('background-position', '' + x + '% ' + y + '%');
    });
  }

  zoom() {
    $(document).on('click', '.zoom-thumbnail-render', function (e) {
      const self = $(e.currentTarget);
      const breakpoint = Foundation.MediaQuery.current;
      let url = null;

      if (breakpoint === 'medium') {
        url = self.attr('data-img-medium');
      } else if (breakpoint === 'small') {
        url = self.attr('data-img-small');
      } else {
        url = self.attr('data-img-large');
      }

      const modal = $('#zoom-modal');
      const render = $('#zoom-render');
      let index = self.attr('data-index');

      self.addClass('active').siblings().removeClass('active');

      if (render.find('.img-render-panning').length > 0) {
        render.addClass('img-loading');
      } else {
        render.addClass('loading');
      }

      let changeImage = function () {
        const img = new Image();
        img.src = url;
        img.classList.add('img-render-panning');
        img.setAttribute('data-index', index);
        img.referrerPolicy = 'no-referrer';

        img.addEventListener('load', function () {
          if (window.device.type === 'mobile' || window.device.type === 'tablet') {
            render.removeClass('loading img-loading');
            img.classList.add('fade-in');
            render.append(img);
            render.find('.img-render-panning[data-index="' + index + '"]').siblings().removeClass('fade-in');
            modal.scrollTop(0);
            modal.scrollLeft(img.width / 4);
          } else {
            render.css('background-image', 'url(' + url + ')');
            render.removeClass('loading');
          }
        });
      };

      if (render.find('.img-render-panning[data-index="' + index + '"]').length) {
        render.removeClass('img-loading').find('.img-render-panning[data-index="' + index + '"]').addClass('fade-in').siblings()
          .removeClass('fade-in');
        modal.scrollTop(0);
        modal.scrollLeft($('.img-render-panning[data-index="' + index + '"]').width() / 4);
      } else {
        changeImage();
      }
    });
  }

  toggleShare() {
    $('.side-details').on('click', '.share-label', function (e) {
      e.preventDefault();
      const self = $(e.currentTarget);
      self.addClass('expanded').next().toggleClass('expanded');

      if (!self.next().hasClass('expanded')) {
        self.next().find('a:last').one('webkitTransitionEnd transitionend', function (event) {
          self.removeClass('expanded');
        });
      }
    });
  }

  productSetImage() {
    let generateImages = function (render, indexToFind) {
      render = document.getElementById(render);
      const firstImg = document.getElementById('img-render');

      $('.set-items-render').each(function (index, el) {
        const self = $(el);
        const url = self.attr('data-img-large');
        const img = new Image();
        // let counter = self.parent().attr('data-index');

        img.classList.add('img-layer');
        img.src = url;
        img.setAttribute('data-index', (index + 1));
        img.addEventListener('load', function () {
          if (document.querySelector('#image')) {
            document.querySelector('#image').appendChild(img);
            document.querySelector('#image').classList.remove('loading');
          } else {
            render.appendChild(img);
            render.classList.remove('loading');
          }

          firstImg.classList.add('fade-out');
          $('.img-layer[data-index="' + indexToFind + '"]').addClass('fade-in');
        });
      });
    };

    $(document).on({
      mouseenter: function (e) {
        $('.set-items').each(function (index, el) {
          const self = $(el);
          self.attr('data-index', (index + 1));
        });
        const $sideImage = $('#side-set-image');
        const self = $(e.currentTarget);
        let counter = self.attr('data-index');

        if (window.device.type === 'mobile' || window.device.type === 'tablet') {
          return;
        }

        if ($sideImage.is(':visible')) {
          if ($sideImage.find('.img-layer').length > 0) {
            $sideImage.find('img[data-index="' + counter + '"]').addClass('fade-in');
            $sideImage.find('.img-render').addClass('fade-out');
          } else {
            if ($sideImage.find('#image').length > 0) {
              $sideImage.find('#image').addClass('loading');
            } else {
              $sideImage.addClass('loading');
            }

            generateImages('side-set-image', counter);
          }
        }
      },
      mouseleave: function (e) {
        const $sideImage = $('#side-set-image');
        if ($sideImage.is(':visible')) {
          if ($sideImage.find('#image').length > 0) {
            $sideImage.find('#image').removeClass('loading');
          } else {
            $sideImage.removeClass('loading');
          }

          $sideImage.find('img').removeClass('fade-out fade-in');
        }
      }
    }, '.set-items');
  }

  notifyMe() {
    $('.notify-form #list-size').on('change', function (e) {
      var masterProductId = $('.product-detail').data('pid'); // TODO: find a better way to retrieve this
      var selectedColorId = $('a.swatch-color.selected').data('attr-value');
      var sizeId = $('button.custom-select__option.custom-select__option--value.size-option').text(); // TODO: find a better way to retrieve this
      var productID = '' + masterProductId + '_' + selectedColorId + '_' + sizeId;
      console.log('Yo! Changed size in notify me! Notify me about this: ' + productID);
      $('input#productID').val(productID);
    });

    $('.notify-form button.submit').click(function (e) {
      e.preventDefault();
      var $form = $('form.notify-form');
      var action = $form.attr('action');

      $.ajax({
        url: action,
        type: 'post',
        data: $form.serialize(),
        success: function (response) {
          $('.notify-modal .modal-content .response-header').html(response.msg.lead);
          $('.notify-modal .modal-content .response-header').removeClass('hide');
          $('.notify-modal .modal-content p').html(response.msg.content);
          $('.notify-modal .modal-content form').hide();
        },
        error: function () { }
      });
    });
  }

  sizeGuide() {
    if (!$('#size-guide-modal').length) return;

    $(document).on('tabToggle', function (e, tab) {
      const label = $('[data-target=\'' + tab + '\']').data('label');
      if (label) $('#tab-title').text(label);
    });

    $('#measuring-guide-sizes').change(function (e) {
      const info = $(e.currentTarget).find(':selected').data('info');
      $('#measuring-guide-bodyparts').empty();
      if (info) {
        info.forEach(function (data) {
          $('#measuring-guide-bodyparts').append([
            '<div class="size-section">',
            '<h6>' + data.bodyPartRefence + ' ' + data.bodyPart + ' (' + data.value + ')</h6>',
            '</div>'
          ].join(''));
        });
      }
    });
  }

  setItemClick() {
    var prdSetDetail = $('.product-set-detail');
    $('.set-item a.product-link').on('click', function (e) {
      var $self = $(e.currentTarget);
      var setItem = $self.closest('.set-item');
      var setItemPrice = setItem.find('.price-wrapper');
      if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
          event: 'productClick',
          ecommerce: {
            click: {
              actionField: {
                list: 'look|' + prdSetDetail.find('.product-set-title').text().trim()
              },
              products: [{
                name: setItem.data('name'),
                id: setItem.data('masterpid'),
                price: setItemPrice.data('pmin'),
                brand: 'twinset milano',
                category: setItem.data('category'),
                position: setItem.data('position')
              }]
            }
          }
        });
      }
    });

    // move in product/indez.js add-to-cart event
    // $('.set-item .cart-and-ipay').on('click', function (e) {
    //     var $self = $(e.currentTarget);
    //     var setItem = $self.closest('.set-item');
    //     var setItemPrice = setItem.find('.price-wrapper');
    //     var selectedSize = setItem.find('.list-size').find(":selected").text().trim();
    //     if (typeof dataLayer !== 'undefined') {
    //         dataLayer.push({
    //             'event': 'shop_by_look_add_to_cart',
    //             'ecommerce': {
    //                  'add': {
    //                     'actionFields' : { 'list' : 'look|' + prdSetDetail.find('.product-set-title').text().trim() },
    //                     'products': [{
    //                                 'name': setItem.data('name'),
    //                                 'id': setItem.data('masterpid'),
    //                                 'price': setItemPrice.data('pmin'),
    //                                 'brand': 'twinset milano',
    //                                 'category': setItem.data('category'),
    //                                 'variant': setItem.data('variant'),
    //                                 'quantity': "1",
    //                                 'dimension14' : setItem.data('dimension14'),
    //                                 'dimension15' : setItem.data('dimension15'),
    //                                 'dimension16' : selectedSize
    //                             }]
    //                         }
    //                     }
    //                 });
    //     }
    // });

    $(document).ready(function () {
      if (typeof dataLayer !== 'undefined' && $('.product-set-detail').length) {
        dataLayer.push({
          event: 'shop_by_look_detail',
          ecommerce: {
            detail: {
              products: [{
                name: 'look|' + prdSetDetail.find('.product-set-title').text().trim(),
                id: prdSetDetail.data('pid'),
                //   'price': $$$total_price$$$,
                brand: 'twinset milano',
                variant: '',
                category: '',
              }]
            }
          }
        });

        var itemList = $('.set-items').find('.set-item');
        var itemsImpression = [];
        $.each(itemList, function (itemIndex) {
          var element = $(itemList[itemIndex]);
          var elementPrice = element.find('.price-wrapper');
          itemsImpression.push({
            name: element.data('name'),
            id: element.data('masterpid'),
            price: elementPrice.data('pmin'),
            brand: 'twinset milano',
            category: element.data('category'),
            list: 'look|' + prdSetDetail.find('.product-set-title').text().trim(),
            position: (itemIndex + 1)
          });
        });
        dataLayer.push({
          event: 'shop_by_look_product_impression',
          ecommerce: {
            impressions: itemsImpression
          }
        });
      }
    });
  }

  visibilitySizeGuideModalElements(){
    /*
    This Observer is used to intercept the opening of size Guide Modal and to show
    the advice of scrollable table if it is such.
    */
    const handleIntersection = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          var table = $('#size-guide-modal .responsive-table')[0];
          if(table.scrollWidth > table.clientWidth){
            $('#tab-scroll-description').show();
          }
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    const target = document.getElementById('size-guide-modal');
    observer.observe(target);
  }
}

const ProductDetail = new detail();



// WEBPACK FOOTER //
// ./assets/scripts/pdp.js